import { DateTime } from 'luxon'

declare const ShiftReasonIDSymbol: unique symbol
export type ShiftReasonID = number & { [ShiftReasonIDSymbol]: never }

export interface ShiftReasonJson {
    id: number
    name: string
    archived_at: string | null
    permissions: { can_edit: boolean }
}

export class ShiftReason {
    id: ShiftReasonID
    name: string

    archivedAt: DateTime | null = null

    permissions: { canEdit: boolean } = { canEdit: false }

    constructor(
        id: number,
        name: string,
        archivedAt: DateTime | null = null,
        permissions: { canEdit: boolean } = { canEdit: false },
    ) {
        this.id = id as ShiftReasonID
        this.name = name
        this.archivedAt = archivedAt
        this.permissions = permissions
    }

    static fromJson(json: ShiftReasonJson): ShiftReason {
        return new ShiftReason(
            json.id,
            json.name,
            json.archived_at ? DateTime.fromISO(json.archived_at) : null,
            { canEdit: json.permissions.can_edit },
        )
    }
}
